export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100/80 text-secondary-700 text-sm font-medium mb-4 whitespace-nowrap">
            联系我们
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            投稿与合作
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            欢迎影视创作者、资源分享者与我们联系，共同打造更好的免费影视平台
          </p>
        </div>

        <div className="max-w-xl mx-auto">
          <div className="rounded-2xl bg-background-100 border border-background-200/60 p-8 md:p-10">
            <div className="space-y-5">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-primary-500 text-xl"></i>
                </div>
                <div>
                  <p className="text-sm text-foreground-500">投稿邮箱</p>
                  <p className="text-base font-semibold text-foreground-900">contributor@91free.com</p>
                </div>
              </div>

              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-chat-smile-2-line text-accent-500 text-xl"></i>
                </div>
                <div>
                  <p className="text-sm text-foreground-500">合作咨询</p>
                  <p className="text-base font-semibold text-foreground-900">partner@91free.com</p>
                </div>
              </div>

              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-xl bg-secondary-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-wechat-line text-secondary-600 text-xl"></i>
                </div>
                <div>
                  <p className="text-sm text-foreground-500">官方公众号</p>
                  <p className="text-base font-semibold text-foreground-900">91免费影视</p>
                </div>
              </div>
            </div>

            <p className="mt-8 text-sm text-foreground-400 leading-relaxed text-center">
              我们会在 48 小时内回复您的邮件。影视资源投稿请附上详细片单与来源说明。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}